export default "__VITE_ASSET__CGCaAxPQ__"